import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Product extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";

    public productList: BASEAPI.Product[] = [];
    public type: "SALE" | "END" = "END";
    public nowDate: Date  = new Date();

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {

        // this.type = this.$route.query.type === "END" ? "END" : "SALE";

        let res = await BASEAPI.ProductController.getProductListUsingGET(undefined, this.type).catch(AxiosErrorHandler);
        if (!isAxiosError(res)) {
            this.productList = res.data;
        }

        this.nowDate = new Date(res.headers.date);
    }

    public changeType(type: string){
        this.$router.replace("/product?type=" + type);
        this.init();
    }

    public getDayOfWeek(date: string){
        let yearStr: number = Number(date.substring(0, date.indexOf('年')));
        let monthStr: number = Number(date.substring(date.indexOf('年') + 1, date.indexOf('月')));
        let dayStr: number = Number(date.substring(date.indexOf('月') + 1, date.indexOf('日')));
        const dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ] ;
        let newDate = new Date( yearStr, monthStr - 1 , dayStr);
        return(dayOfWeekStrJP[newDate.getDay()]);
    }

    public checkSales(date: Date){
        if(new Date(date) > this.nowDate!){
            return false
        } else {
            return true;
        }
    }

    public getImgList(product: BASEAPI.Product){
        let allImgList: {img: string, title: string}[] = [];
        let imgList: {img: string, title: string}[] = [];
        product.productPrizeGroupList?.forEach(productPrizeGroup => {
            productPrizeGroup.prizeList?.forEach(prize => {
                allImgList.push({img: prize.image, title: prize.title});
            })
        })

        if(allImgList.length < 4){
            return [];
        }

        for(let i = 0; i < 4; i++){
            let rndInt = Math.floor(Math.random() * allImgList.length);
            imgList.push(allImgList[rndInt]);
            allImgList.splice(rndInt,1)
        }

        return imgList;
    }
}
